import Cookies from "js-cookie";
import React, { useState } from "react";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { Button, Upload } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import NumberFormat from "react-number-format";
import { FaLongArrowAltDown } from "react-icons/fa";
import ErrorDiv from "../../../components/helpers/ErrorDiv";
import { useHistory, useParams } from "react-router-dom";
import {
  convertCodeProduct,
  convertUrlUploadProduct,
} from "./helpers/convertUrlUpload";
import qs from "qs";

const UploadProduct = () => {
  const [fileList, setFileList] = useState([]);
  const [errors, setErrors] = useState({});
  let { code_product } = useParams();
  const history = useHistory();

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const validate = () => {
    const newErrors = {};

    if (fileList.length === 0) {
      newErrors.file = "File belum di upload";
    }

    return newErrors;
  };

  const dragPhoto = {
    customRequest: dummyRequest,
    name: "file",
    multiple: false,
    onChange(info) {
      setFileList([info.file]);
    },
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let url = convertUrlUploadProduct(code_product);
      let formData = new FormData();
      formData.append("file", fileList[0]);

      AxiosCustomPost(
        url,
        formData,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type": "multipart/form-data",
        }),
        (response) => {
          console.log(response.data);
          history.replace({
            pathname: `/product-category/${code_product}`,
          });
        },
        (error) => {
          console.log(error?.response?.data?.error);
          console.log(error?.response?.data);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Upload Gagal: ${error?.response?.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }
  };

  const downloadTemplate = () => {
    let url = `${convertUrlUploadProduct(code_product)}/template`;
    let filename = `${convertCodeProduct(code_product)}_template.xlsx`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        {},
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        console.log("handleExportExcel", error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };
  return (
    <>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Upload Produk"} />
              <Breadcrumb current={"Upload Produk"} />
            </div>

            <div className="ml-auto">
              <Button
                onClick={downloadTemplate}
                className="ml-3 btn text-white font-weight-semi-bold"
                style={{ backgroundColor: "#F5CB58", width: 200 }}
              >
                Download Contoh File
              </Button>
            </div>
          </div>

          <Upload.Dragger
            {...dragPhoto}
            beforeUpload={() => false}
            fileList={fileList}
            className="p-3"
          >
            <p className="ant-upload-drag-icon">
              <FaLongArrowAltDown style={{ fontSize: 40, color: "#F5CB58" }} />
            </p>
            <p className="ant-upload-text font-weight-bold">
              Tarik dan letakkan file disini
            </p>
            <p className="ant-upload-hint">atau</p>
            <p className="ant-upload-hint">
              <Button
                style={{
                  margin: "5px",
                  border: "0.75px solid #DCDCDC",
                  borderRadius: 6,
                }}
              >
                Pilih Foto
              </Button>
            </p>

            <p className="ant-upload-hint">Format xlsx</p>
          </Upload.Dragger>
          <ErrorDiv error={errors?.file} />

          {/* <div className="pr-0 d-flex mt-3">
            <div className="col-4 pl-0 align-items-center">
              <p>Start Row</p>
              <NumberFormat
                value={startRow}
                isNumericString={true}
                onValueChange={(e) => setStartRow(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  height: 32,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                  borderRadius: 4,
                }}
              />
              <ErrorDiv error={errors?.startRow} />
            </div>

            <div className="col-4 pl-0 align-items-center">
              <p>End Row</p>
              <NumberFormat
                value={endRow}
                isNumericString={true}
                onValueChange={(e) => setEndRow(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  height: 32,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                  borderRadius: 4,
                }}
              />
              <ErrorDiv error={errors?.endRow} />
            </div>
          </div> */}
          <div className="ml-auto d-flex align-items-end justify-content-end mt-5">
            <button
              className="ml-3 btn bgc-fff font-weight-semi-bold px-5"
              style={{ borderColor: "#DCDCDC", color: "#2C465C" }}
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
            <button
              className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold px-5"
              onClick={handleSubmit}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadProduct;
